"use client";

import type { ReactElement } from "react";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";
import { CareersRecruiteeEmbed } from "./careers-recruitee-embed";

/** Verbatim Recruitee embed config — do not restyle; it's the account's own widget setup. */
export const RECRUITEE_WIDGET_CONFIG = {
  companies: [119273],
  detailsMode: "popup",
  language: "en",
  departmentsFilter: [],
  tagsFilter: [],
  themeVars: {
    primary: "#2d2d2d",
    secondary: "#141217",
    text: "#5d566c",
    textDark: "#141217",
    fontFamily:
      '"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;',
    baseFontSize: "16px",
  },
  flags: {
    showLocation: true,
    showCountry: true,
    showCity: true,
    showState: false,
    showLocationName: true,
    showWorkModel: true,
    groupByLocation: false,
    groupByState: false,
    groupByDepartment: true,
    groupByCompany: false,
  },
};

/** Live open-positions listing (Recruitee widget) on a white panel — the
 * anchor target for every jobs CTA. */
export function CareersJobsSection(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].jobs;

  return (
    <section id="jobs" className="dvf-section c2-center">
      <div className="dvf-section-inner">
        <h2 className="dvf-section-title">{t.title}</h2>
        <CareersRecruiteeEmbed config={RECRUITEE_WIDGET_CONFIG} />
      </div>
    </section>
  );
}
